import script from "./NewUser.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewUser.vue?vue&type=script&setup=true&lang=ts"

import "./NewUser.vue?vue&type=style&index=0&id=bdc3e746&lang=scss"

const __exports__ = script;

export default __exports__